"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = IconButton;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _colors = require("../../../theme/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: function root(props) {
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        cursor: 'pointer',
        height: props.height || '40px',
        width: props.width || '40px',
        backgroundColor: props.color && _colors.colors[props.color] ? _colors.colors[props.color] : _colors.colors.primaryGreen,
        '&:hover': {
          backgroundColor: props.color === 'primaryGreen' ? _colors.colors.primaryGreenHover : _colors.colors.primaryGreen
        }
      };
    },
    label: {
      margin: '0.5rem'
    }
  };
});

function IconButton(_ref) {
  var id = _ref.id,
      onClick = _ref.onClick,
      children = _ref.children,
      label = _ref.label,
      labelPosition = _ref.labelPosition,
      props = _objectWithoutProperties(_ref, ["id", "onClick", "children", "label", "labelPosition"]);

  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    direction: labelPosition === 'up' || labelPosition === 'down' ? 'column' : 'row',
    alignItems: "center"
  }, label && (labelPosition === 'up' || labelPosition === 'left') ? /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.label,
    variant: "body2"
  }, label) : null, /*#__PURE__*/_react["default"].createElement(_core.Box, _extends({
    id: id,
    className: classes.root,
    onClick: onClick
  }, props), children), label && (labelPosition === 'down' || labelPosition === 'right') ? /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.label,
    variant: "body2"
  }, label) : null);
}

IconButton.defaultProps = {
  labelPosition: 'down'
};